<template>
  <div class="container">
    <div>
      <div class="dept-title">{{ selectedDepartmentData.roomText }}</div>
      <div class="week-box">
        <div
          @click="select(wkItem)"
          class="week-item"
          v-for="(wkItem, index) in reckonDateList"
          :key="index"
        >
          <div class="select-box">
            <div
              :class="
                wkItem.dateStr == selectWk
                  ? 'wk-item-day-active'
                  : 'wk-item-day'
              "
            >
              {{ wkItem.ListDays }}
            </div>
          </div>
          <div class="wk-item-text">{{ wkItem.ListWeeks }}</div>
        </div>
      </div>

      <div class="doctor-list" :style="getStyles()">
        <div class="doctor-item" v-for="(docItem, index) in list" :key="index">
          <div class="horn">
            {{
              docItem.SESSION_CODE == '01'
                ? '白天'
                : docItem.SESSION_CODE == '02'
                ? '晚上'
                : docItem.SESSION_CODE == '04'
                ? '上午'
                : docItem.SESSION_CODE == '05'
                ? '下午'
                : docItem.SESSION_CODE == '06'
                ? '全天'
                : docItem.SESSION_CODE == '07'
                ? '复诊'
                : docItem.SESSION_CODE == '08'
                ? '复诊1'
                : docItem.SESSION_CODE == '09'
                ? '小夜班'
                : docItem.SESSION_CODE == '10'
                ? '小夜复'
                : '其他'
            }}
          </div>
          <div class="doctor-box">
            <div class="card-item">
              <div class="head-box" @click="toDoctorDetail(docItem)">
                <img :src="getImg(docItem.avatar)" />
              </div>
              <div class="head-name-detail">
                <div class="detail-item">
                  {{ docItem.doctName }}
                </div>
                <div class="detail-item">
                  {{ docItem.reglevlName }}
                </div>
                <div class="detail-item">科室名称：{{ docItem.deptName }}</div>
              </div>
            </div>
            <div class="do">￥{{ docItem.totCost }}</div>
          </div>
          <div class="doctor-num">
            <div class="bet betCA">剩余号源：{{ docItem.hyLeftNum }}</div>
            <div class="bet" @click="goPatientList(docItem)">
              立即挂号
              <van-icon name="arrow" />
            </div>
          </div>
        </div>
        <van-empty
          v-if="list == ''"
          class="custom-image"
          image="https://img.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无数据"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getBaseUrl } from '../../utils/request'
import { findBySectionId } from '@/api/api'
import { reckonDate, _date_ } from '../../utils/calculationDate'
import { Dialog } from 'vant'
export default {
  name: 'selectDoctor',
  data() {
    return {
      selectedDepartmentData: [],
      selectWk: '',
      reckonDateList: [],
      list: []
    }
  },
  created() {},
  mounted() {
    Dialog.alert({
      title: '温馨提示',
      confirmButtonColor: 'rgb(22,119,254)',
      messageAlign: 'left',
      message:
        '1、请携带身份证/医保卡在预约时间之前到达医院，如需取消预约次日及后期号源，请在就诊日前一日0点前操作。\n\n 2、预约挂号就诊时间为当日就诊患者排序的依据，时间仅为预计的就诊时间，实际就诊时间需由现场就诊情况决定。请患者于预约时间前30分钟到场等候，以免过号影响就诊。'
    }).then(() => {
      // on close
    })
    this.reckonDateList = reckonDate()
    //  获取选中的科室数据
    this.selectedDepartmentData = JSON.parse(localStorage.getItem('department'))
    this.getData(
      this.selectedDepartmentData.code,
      this.selectedDepartmentData.dateStr,
      this.selectedDepartmentData.clinicRoomNo
    )
    // 默认当天时间
    this.selectWk = this.selectedDepartmentData.dateStr
  },
  methods: {
    getImg(url) {
      if (url) return getBaseUrl() + url
      else return require('@/assets/head.jpg')
    },
    getStyles() {
      if (this.list == '') {
        return { backgroundColor: '#ffffff' }
      } else {
        return { backgroundColor: '#f2f8f3' }
      }
    },
    getData(id, dateStr, clinicRoomNo) {
      this.$loading.show()
      // let data = {
      //   deptCode: id,
      //   admDate: dateStr,
      //   clinicRoomNo: clinicRoomNo
      // }
      let data = {
        deptCode: clinicRoomNo,
        admDate: dateStr
      }
      findBySectionId(data).then(res => {
        try {
          this.list = JSON.parse(res.msg).body.hyList
          this.$loading.hide()
        } catch (error) {
          console.error(error)
        }
      })
    },
    select(item) {
      this.selectWk = item.dateStr
      this.getData(
        this.selectedDepartmentData.code,
        item.dateStr,
        this.selectedDepartmentData.clinicRoomNo
      )
    },
    // 挂号
    goPatientList(docItem) {
      docItem.selectPeople = 'select'
      this.$router.push({
        name: 'patientList',
        query: docItem
      })
    },
    // 查看医生主页
    toDoctorDetail(code) {
      this.$router.push({
        name: 'doctorDetail',
        query: {
          status: 'selectDoctor',
          docCode: JSON.stringify(code)
        }
      })
    },
    dateProp(datecode) {
      return _date_(datecode)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  height: 100vh;
}
.dept-title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  padding: 0 10px;
  border-top: 1px solid #ebedf0;
  border-bottom: 1px solid #ebedf0;
}
.week-box {
  width: 100%;
  overflow-x: auto;
  height: 70px;
  border-bottom: 1px solid #ebedf0;
  display: flex;
}
.week-item {
  width: 14vw;
  min-width: 14vw;
  font-size: 16px;
  text-align: center;
  .select-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .wk-item-day {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 25px;
      width: 25px;
      border-radius: 12.5px;
      margin-top: 10px;
      &-active {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 25px;
        width: 25px;
        border-radius: 12.5px;
        margin-top: 10px;
        background-color: #3478f7;
        color: #fff;
      }
    }
  }
  .wk-item-text {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 3px;
  }
  .color-blue {
    color: #3478f7;
  }
  .color-red {
    color: red;
  }
}
.doctor-list {
  height: calc(100vh - 110px);
  max-height: calc(100vh - 110px);
  overflow-y: auto;
  width: 100vw;
  padding: 10px;
  .doctor-item {
    width: 100%;
    background: #fff;
    box-shadow: 3px 0 9px #ebedf0;
    padding: 0px 10px 0px 10px;
    font-size: 16px;
    margin-bottom: 15px;
    position: relative;
    border-radius: 10px;
    border-top-right-radius: 15px;
    .horn {
      position: absolute;
      right: 0px;
      top: 0px;
      color: #ffffff;
      background-color: rgb(237, 125, 84);
      padding: 5px 10px;
      border-top-right-radius: 15px;
      font-size: 16px;
    }
    .doctor-box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .card-item {
        padding: 10px 12px;
        display: flex;
        align-items: center;
        .head-box {
          width: 60px;
          height: 60px;
          border-radius: 100%;
          img {
            width: 60px;
            height: 60px;
            border-radius: 20px;
          }
        }
        .head-name-detail {
          width: calc(100% - 50px);
          .detail-item {
            width: 100%;
            height: 19px;
            display: flex;
            align-items: flex-end;
            padding-left: 10px;
            color: #666;
            font-size: 16px;
          }
        }
      }
      .do {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color: #3478f7;
        margin-top: 20px;
        margin-right: 5px;
      }
    }
    .doctor-num {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 0px 0px 8px 10px;
      justify-content: space-between;
      .bet {
        display: flex;
        align-items: center;
        color: #3478f7;
      }
      .betCA {
        color: #444343;
      }
    }
  }
}
</style>
